
// eslint-disable-next-line no-unused-vars
import IConfigurationService from "../interfaces/configuration_service";

// eslint-disable-next-line no-unused-vars
import SelectedDance from "@/model/selected_dance";
// eslint-disable-next-line no-unused-vars
import { defineComponent, inject, onBeforeMount, PropType, reactive, ref } from "vue";
// eslint-disable-next-line no-unused-vars
import { IRegionFilters } from "@/interfaces/region_filters";
// import AudioPlayer from "./audio_player.vue";

export default defineComponent({
  // components: { AudioPlayer },
  name: "TrackList",
  emits: ["track-selected", "pause-selected"],
  props: {
    panelHeader: String,
    audioFiles: Object as PropType<Array<SelectedDance>>,
    selectedRegion: Object as PropType<IRegionFilters>
  },
  setup(props: any, { emit }) {
    const tracks = reactive(props.audioFiles);
    const configurationService = inject<IConfigurationService>("configurationService");
    const isThisAFeis= ref<string>("false");
    const isThisAClass= ref<string>("false");
    const bunLabel = ref<string>("Bun Grad");
    const tusLabel = ref<string>("Tus Grad");
    const meanLabel = ref<string>("Mean Grad");
    const openLabel = ref<string>("Open");

		if (!configurationService)
    {
      throw new Error("Configuration service not initialised");
    }
    
    // Option button handler
    function optionSelected(track: SelectedDance) {
      for(const trk of tracks)
      {
        trk.isPlaying = false;
      }
      track.isPlaying = true;
      emit("track-selected", track);
    }

    function pauseSelected(track: SelectedDance) {
      track.isPlaying = false;
      emit("pause-selected", track);
    }

    function getFeisStatusAndLabels()
    {
      // const propIsAtFeis = props.selectedRegion?.map((item: IRegionFilters) => item?.isFeis);
      // if (propIsAtFeis)
      // {
        isThisAFeis.value = props.selectedRegion?.map((item: IRegionFilters) => item?.isFeis);
        isThisAClass.value = props.selectedRegion?.map((item: IRegionFilters) => item?.isClass);
        bunLabel.value = props.selectedRegion?.map((item: IRegionFilters) => item?.bunTitle);
        tusLabel.value = props.selectedRegion?.map((item: IRegionFilters) => item?.tusTitle);
        meanLabel.value = props.selectedRegion?.map((item: IRegionFilters) => item?.meanTitle);
        openLabel.value = props.selectedRegion?.map((item: IRegionFilters) => item?.openTitle);
      //   if (propIsAtFeis?.length > 0)
      //   {
      //     isThisAFeis.value = propIsAtFeis[0];
      //     console.log(`BUN LABEL: ${bunLabel.value}`)
      //     console.log(`TUS LABEL: ${tusLabel.value}`)
      //     console.log(`MEAN LABEL: ${meanLabel.value}`)
      //     console.log(`OPEN LABEL: ${openLabel.value}`)
      //     console.log(`isThisAFeis: ${JSON.stringify(propIsAtFeis[0])} truthy: ${propIsAtFeis[0] === "true"} truthy2: ${isThisAFeis.value === 'true'}`)
      //   }
      // }
    }

    onBeforeMount(function()
    {
      getFeisStatusAndLabels();
    });

    return {
      tracks,
      optionSelected,
      pauseSelected,
      isThisAFeis,
      bunLabel,
      tusLabel,
      meanLabel,
      openLabel
    };
  },
});
